import React from "react";
import { Polygon, Svg, Text, View, StyleSheet } from "@react-pdf/renderer";
import { PDF_FONT, PDF_FONT_FAMILY } from "./pdfTheme";

function DeltaArrow({
  direction,
  color,
  size,
}: {
  direction: "up" | "down";
  color: string;
  size: number;
}): React.ReactElement {
  const points =
    direction === "up"
      ? `${size / 2},1 ${size - 0.5},${size - 0.5} 0.5,${size - 0.5}`
      : `0.5,0.5 ${size - 0.5},0.5 ${size / 2},${size - 0.5}`;

  return (
    <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <Polygon points={points} fill={color} />
    </Svg>
  );
}

type Props = {
  direction: "up" | "down";
  pct: string;
  color: string;
  fontSize?: number;
  fontWeight?: "normal" | "bold";
  /** Wrap as `(▲ 6,1%)` to match web platform rows. */
  parens?: boolean;
  /** Row alignment for mixed text + SVG (compact KPI vs platform rows). */
  align?: "center" | "flex-end";
};

export function MetricsPdfDeltaIndicator({
  direction,
  pct,
  color,
  fontSize = 12,
  fontWeight = PDF_FONT.semibold,
  parens = false,
  align = "center",
}: Props): React.ReactElement {
  const arrowSize = Math.max(5, Math.round(fontSize * 0.55));

  return (
    <View style={[styles.row, { alignItems: align }]}>
      {parens ? (
        <Text
          style={[
            styles.text,
            { fontSize, fontWeight, color, lineHeight: 1 },
          ]}
        >
          (
        </Text>
      ) : null}
      <DeltaArrow direction={direction} color={color} size={arrowSize} />
      <Text
        style={[
          styles.text,
          styles.pct,
          { fontSize, fontWeight, color, lineHeight: 1 },
        ]}
      >
        {pct}
        {parens ? ")" : ""}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    fontFamily: PDF_FONT_FAMILY,
  },
  text: {
    fontFamily: PDF_FONT_FAMILY,
  },
  pct: {
    marginLeft: 2,
  },
});
